import type { SVGProps } from "react";
import * as React from "react";
const SvgArrowUpS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="m12 8 6 6H6l6-6Z" />
  </svg>
);
export default SvgArrowUpS;
